import {
  Card,
  CardHeader,
  CardBody,
} from '../../../_metronic/_partials/controls';
import { useIntl } from 'react-intl';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import { Row, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { ether } from '../../../helpers/ethers';
import { tokenizationAbi } from '../../../config/abi';
import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ErrorMessage } from '@hookform/error-message';
import useContractInteraction from '../../../helpers/useContractInteraction';
import { useAppKit } from '@reown/appkit/react';
import { connectionContext } from '../../connect-wallet/ConnectionStatus';
import { toast } from 'react-toastify';
import { useReadContract } from 'wagmi';

export const TokenizationWithdrawEarnings = () => {
  const intl = useIntl();
  const { open } = useAppKit();
  const { address, isConnected, isReconnecting, isConnecting } =
    useContext(connectionContext);
  const { isLoading, error, interact, isSuccess } = useContractInteraction();
  const { payments } = useSelector((state) => state.paymentGateway);
  const { currentAdmin } = useSelector((state) => state.adminAuth);
  const blockchainOption = payments.filter(Boolean).map((option) => ({
    value: option.chainId,
    label: option.title,
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    control,
    setValue,
    getValues,
  } = useForm({});

  const [contractDetails, setContractDetails] = useState({
    address: payments[0]?.contractAddress || '',
    chainId: getValues('chainId')?.value || '',
  });

  const dispatch = useDispatch();

  const {
    data: readContractData,
    isSuccess: readContractSuccess,
    isError: readContractError,
    error: readContractErrorData,
    refetch: readContractractRefetch,
  } = useReadContract({
    address: contractDetails.address,
    abi: tokenizationAbi,
    chainId: Number(contractDetails.chainId),
    functionName: 'platformEarnings',
    args: [currentAdmin?.walletAddress],
    query: {
      enabled:
        !!contractDetails.address &&
        !!contractDetails.chainId &&
        !!currentAdmin?.walletAddress,
    },
  });

  useEffect(() => {
    dispatch(actions.getPaymentGateway('crypto-payment'));
  }, [dispatch]);

  useEffect(() => {
    if (watch('chainId') || getValues('chainId')) {
      const currentChain = payments.find(
        (payment) => payment.chainId === watch('chainId').value,
      );

      if (currentChain) {
        setContractDetails({
          address: currentChain.tokenizationContractAddress,
          chainId: watch('chainId').value,
        });
      }
    }
  }, [watch('chainId'), getValues('chainId')]);

  useEffect(() => {
    if (readContractSuccess) {
      setValue('earnings', ether.formatEther(readContractData));
    }
    if (readContractError) {
      toast.error(readContractErrorData.details);
    }
  }, [readContractData, readContractErrorData]);

  const handleSubmitForm = () => {
    if (!isConnected) {
      open();
      return;
    } else {
      interact(
        contractDetails.address,
        tokenizationAbi,
        'withdrawEarnings',
        [],
        contractDetails.chainId,
        address,
        '0',
      );
    }
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Earnings withdraw successfully');
      readContractractRefetch();
    }

    if (error) {
      toast.error(error);
    }
  }, [isSuccess, error]);

  return (
    <>
      <Card className='mt-5'>
        <CardHeader
          title='Withdraw Earnings (Tokenization)'
        />
        <CardBody className='px-4 py-6 pt-0'>
          <Row className='justify-content-md-center'>
            <Col md={11}>
              <Form>
                <div className='row'>
                  <div className='col-md-12 form-group floating-input-field-wrapper mb-5'>
                    <label className='floating-input-field-label-static'>
                      {intl.formatMessage({
                        id: 'BLOCKCHAIN.SELECT',
                      })}
                      <span className='text-danger'>*</span>
                    </label>
                    <Controller // Use Controller for Select
                      control={control}
                      name='chainId'
                      defaultValue={blockchainOption[0]}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isSearchable={false}
                          placeholder={intl.formatMessage({
                            id: 'BLOCKCHAIN.SELECT',
                          })}
                          options={blockchainOption}
                          classNamePrefix='react-select'
                          className={classNames({
                            'is-invalid': errors.chainId,
                          })}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 form-group floating-input-field-wrapper mb-5'>
                    <Form.Control
                      type='number'
                      name='earnings'
                      placeholder=' '
                      disabled={true}
                      className={classNames('floating-input-field-item', {
                        'is-invalid': errors.earnings,
                      })}
                      {...register('earnings')}
                    />
                    <label className='floating-input-field-label'>
                      {intl.formatMessage({
                        id: 'WITHDRAW.EARNING.LABEL',
                      })}{' '}
                      <span className='text-danger'>*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      name='earnings'
                      render={({ message }) => (
                        <div className='invalid-feedback'>{message}</div>
                      )}
                    />
                  </div>
                </div>
                <button
                  type='button'
                  className='btn btn-secondary px-10 text-white py-1'
                  disabled={isReconnecting || isConnecting || isLoading}
                  onClick={handleSubmit(handleSubmitForm)}
                >
                  {isReconnecting || isConnecting || isLoading ? (
                    <span
                      className='spinner-border spinner-border-sm'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  ) : (
                    intl.formatMessage({ id: 'WITHDRAW' })
                  )}
                </button>
              </Form>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};
